import type { Document } from "../document/Document";
import type { Command } from "./Command";

/**
 * Rename the document. Fully undoable — undo restores the previous name.
 * Photoshop equivalent: double-clicking the document title bar.
 */
export class RenameDocumentCommand implements Command {
  readonly kind = "rename-document";
  constructor(private readonly newName: string) {}

  apply(doc: Document): Document {
    return { ...doc, name: this.newName };
  }

  invert(before: Document, _after: Document): Command {
    return new RenameDocumentCommand(before.name);
  }
}
